export const getRangeMarkerStyles = (sentimentValue: number | null): { marginLeft: string } => {
  const multiplier = 50 / 1.5;

  if (!sentimentValue) {
    return {
      marginLeft: "50%",
    };
  }

  return {
    marginLeft: `${50 + sentimentValue * multiplier}%`,
  };
};
